<script lang='ts'>
// import { useNavigate } from "svelte-navigator";
import { EventState } from './shared';
import { markdown } from '../util';
import * as config from '../config.json';

// const navigate = useNavigate();

export let id;
export let state;
export let name;
export let description;
export let start;
export let end;
export let speakers;
export let replayStream;
export let liveStream;

let live;
let dateString;
let startTimeString;
let endTimeString;
let activeStream;
let isExternalShow;

$: live = state === EventState.StartingSoon || state === EventState.Live;
$: activeStream = state === EventState.Replay ? replayStream : liveStream;
$: isExternalShow = activeStream?.type === 'zoom';

$: dateString = start.toLocaleString('default', {month: 'short', day: 'numeric'})
$: startTimeString = start.toLocaleTimeString('default', {hour: 'numeric', minute: '2-digit', hour12: true})
$: endTimeString = end.toLocaleTimeString('default', {hour: 'numeric', minute: '2-digit', hour12: true})

function joinShow(e) {
  if (isExternalShow) {
    window.open(activeStream.url, "_blank");
  } else {
    window.location.href = `/show/${id}`
    // navigate(`/show/${id}`);
  }
}
</script>

<div class="card" class:live>
  <div class="left">
    {#if config.showDateOnScheduleCard}
      <div class="month">{dateString}</div>
    {/if}
    <div class="startTime">{startTimeString} - </div>
    <div class="endTime">{endTimeString}</div>

    {#if state === EventState.Past}

      <div class="action-box past">
        Live session ended
      </div>

    {:else if state !== EventState.Future}

      <div class="action-box" class:live>
        <div>{state === EventState.StartingSoon ? "STARTING SOON" : state === EventState.Live ? "LIVE NOW" : ""}</div>
        {#if activeStream}
          <div class="joinReplayButton" on:click={joinShow}>
            {state === EventState.Replay ? "REPLAY" : "JOIN"}
          </div>
        {/if}
      </div>

    {/if}

  </div>
  <div class="right">
    <div class="title mb-4">{name}</div>
    <div class="desc mb-4">{@html markdown(description)}</div>

    <!-- Removed for the moment -->
    <!-- {#if speakers}
      <div class="speaker-container">
        {#each speakers as speaker}
          <div class="speaker row vcenter nowrap">
            <img style="object-fit:cover" src={speaker.url} /> {speaker.first} {speaker.last}
          </div>
        {/each}
      </div>
    {/if} -->
  </div>
</div>

<style lang="scss">
@import '../util';

.joinReplayButton {
  color: var(--text-secondary);
  background-color: var(--secondary);
  padding: 6px 12px;
}

.card {
  @include shadow;
  display: flex;
  flex-direction: row;
  padding: 24px;
  background-color: white;
  color: black;
  border-left: 16px solid transparent;
  margin-bottom: 16px;
  font-size: 20px;

  @include landscape {
    flex-direction: column;
  }

  &.live {
    border-left-color: var(--secondary);
  }
}

.action-box {
  margin: 16px 0;
  &.live {
    color: var(--secondary);
    font-weight: 700;
    font-size: 20px;
  }

  &.past {
    color: grey;
    font-style: italic;
    font-size: 14px;
  }
}

.left {
  width: 180px;
  @include landscape {
    width: unset;
  }
}

.right {
  flex: 1;
}

.month {
  font-size: 20px;
  font-weight: 300;
}

.startTime {
  font-size: 20px;
  font-weight: 300;
}

.endTime {
  font-weight: 300;
  font-size: 20px;
}

.title {
  font-weight: 700;
  font-size: 20px;
}

.desc {
  font-size: 20px;
  font-weight: 300;
}

 .speaker-container {
  display: inline-flex;
  flex-wrap: wrap;
  margin: -12px 0 0 -12px;
  width: calc(100% + 12px);

  > * {
    margin: 12px 0 0 12px;
  }

  .speaker {
    font-weight: 300;

    img {
      border-radius: 100%;
      height: 52px;
      width: 52px;
      margin-right: 10px;
    }
  }
}
</style>